import { Tab } from "@headlessui/react";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import ConfigContext from "../contexts/AppContext";
import AppContext from "../contexts/AppContext";
import LeftBarContext from "../contexts/LeftBarContext";
import { createBrowserHistory } from "history";
import classNames from "classnames";
import icons from "../icons";
import appFetch from "../appFetch";
import { appendQueryToUri } from "../util/generalUtil";
import apiEndpoints from "../apiEndpoints";

const Icon = styled.div`
  width: 33px;
  height: 33px;
  background: ${({ theme, read }) => theme?.colors.accent};
  color: ${({ theme, read }) => theme?.colors.primary};
  /* border: 1px solid #ffdede; */
  box-sizing: border-box;
  border-radius: 5px;
`;

const NotificationItem = styled.li`
  background: ${({ theme, read }) => (read ? theme?.colors.accent : "inherit")};
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 10px;
`;

const TabHead = styled.div`
  box-shadow: 0px 1px 2px rgb(0 0 0 / 15%);
`;

const Badge = styled.span`
  width: 18px;
  height: 18px;
  font-size: 0.7em;
  color: ${({ theme, active }) =>
    active ? theme?.colors?.primary : "#BBBBBB"};
  background: ${({ theme, active }) =>
    active ? theme?.colors.accent : "#F3F3F3"};
`;

const MenuText = styled.div`
  color: ${({ theme, active }) => (active ? theme.colors?.primary : "#838383")};
  font-weight: ${({ active }) => (active ? "600" : "normal")};
`;

const iconMap = {
  home: "HomeIcon",
  setup: "SetupIcon",
  transaction: "TransactionIcon",
  approval: "ApprovalIcon",
  memo: "MemoIcon",
  open: "OpenIcon",
  dashboard: "DashboardIcon",
  confirmation: "ConfirmationIcon",
  payrollReports: "PayrollReportsIcon",
  otherReports: "OtherReportsIcon",
  essReports: "EssReportsIcon",
  bioData: "BioDataIcon",
  Online: "OnlineIcon",
  Users: "UsersIcon",
  Retail: "RetailIcon",
  Wallet: "WalletIcon",
  Ussd: "UssdIcon",
  Draws: "DrawsIcon",
  ThirdParty: "ThirdPartyIcon",
  Accuracy: "AccuracyIcon",
  Feeds: "FeedsIcon",
  Whatsapp: "WhatsappIcon",
  Error: "ErrorIcon",
  Calender: "CalenderIcon",
  map: "MapIcon",
  Statistics: "StatisticsIcon",
  OtherReports: "OtherReportsIcon",
  Ticket: "TicketIcon",
  Search: "SearchIcon",
  report: "OtherReportsIcon",
  Forms: "FormsIcon",
  module: "FormsIcon",
  reports: "StatisticsIcon",
  money: "MoneyIcon",
  action: "ActionIcon",
  followup: "FollowUpIcon",
  pending: "PendingIcon",
  qualified: "PassIcon",
  schedule: "ScheduledIcon",
  demo: "DemoIcon",
  proposal: "PlanIcon",
  onboarding: "OnboardIcon",
  crm: "CRMIcon",
  sales: "SalesIcon",
  inventory: "InventoryIcon",
  horizontalbarchart: "HorizontalBarIcon",
  verticalbarchart: "VerticalBarIcon",
  scatterchart: "ScatterIcon",
  layout: "LayoutIcon",
  piechart: "PieIcon",
  linechart: "LineIcon",
  "": "setup",
};

function BannerModal2({ options, setLoading, openNewPage, activeMenu }) {
  const [activeItem, setActiveItem] = useState();

  const { config, setConfig } = useContext(ConfigContext);
  const theme = useContext(ThemeContext);
  const { context, setContext } = useContext(AppContext);
  const { menuCollapse, setMobileMenuOpen } = useContext(LeftBarContext);
  // const history = useHistory();
  const history = createBrowserHistory();
  const {
    location: { pathname },
  } = history;

  console.log("initial options", options);
  let groupedOrder = {};
  let optionsGroup = [];
  let optionsGroupLen = -1;

  options.forEach((o) => {
    if (o.group) {
      const groupKey = o.group.trim(); // normalization, optionally use toLowerCase()

      if (!(groupKey in groupedOrder)) {
        groupedOrder[groupKey] = ++optionsGroupLen;
      }

      const index = groupedOrder[groupKey];

      if (!optionsGroup[index]) {
        optionsGroup[index] = {
          name: groupKey,
          icon: o.groupicon,
          options: [o],
        };
      } else {
        optionsGroup[index].options.push(o);
      }
    } else {
      optionsGroup[++optionsGroupLen] = o;
    }
  });

  return (
    <>
      <div className="pt-3 px-3 rounded-lg overflow-hidden z-12">
        <div class="grid w-44">
          {options?.map((item, idx) => {
            let { name, icon, badge } = item;

            let menuIcon = iconMap[icon];
            const patt = new RegExp(`^${name}$`, "i");
            const active = patt.test(activeMenu?.name);

            return (
              <>
                <div
                  key={idx}
                  className="flex items-center justify-between px-2 cursor-pointer"
                  onClick={() => {
                    console.log("the clicked item", item);
                    openNewPage(item);
                  }}
                >
                  <MenuText
                    className="border-color-gray-300 py-2"
                    active={active}
                  >
                    <span className="text-sm">{name}</span>
                    {typeof badge != "undefined" && (
                      <Badge className="font-semibold ml-2 rounded-sm inline-grid place-items-center rounded-xl">
                        {badge}
                      </Badge>
                    )}
                  </MenuText>

                  <div class="cursor-pointer py-2">
                    {icons[menuIcon] &&
                      React.createElement(icons[menuIcon], {
                        width: 20,
                        height: null,
                        fill: active ? theme?.colors?.primary : "#AAAAAA",
                        stroke: active ? theme?.colors?.primary : "#AAAAAA",
                      })}
                  </div>
                </div>
                <div className="border-b border-color-gray-300" />
              </>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default BannerModal2;
